/**
 * @platform Android, iOS
 * @since 7.1.0
 */
export var EventStatus;
(function (EventStatus) {
    /**
     * @platform iOS
     * @since 7.1.0
     */
    EventStatus["NONE"] = "none";
    /**
     * @platform Android, iOS
     * @since 7.1.0
     */
    EventStatus["CONFIRMED"] = "confirmed";
    /**
     * @platform Android, iOS
     * @since 7.1.0
     */
    EventStatus["TENTATIVE"] = "tentative";
    /**
     * @platform Android, iOS
     * @since 7.1.0
     */
    EventStatus["CANCELED"] = "canceled";
})(EventStatus || (EventStatus = {}));
//# sourceMappingURL=event-status.js.map